export default __webpack_public_path__ + "static/media/activeArrowLeft.a8b41540.svg";